// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./images/industry-page-banner-img/banner-railcar.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./images/industry-page-banner-img/banner-printer.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./images/industry-page-banner-img/banner-plant.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./images/industry-page-banner-img/banner-construction.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./images/industry-page-banner-img/information-tech.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}



@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}


.center {

  margin: auto;
  width: 50%;
  padding: 10px;
}

.helloBox {
  border: 1px solid black;
  
  margin: auto;
  width: 30vw;
  
  padding: 10px;
}

/* NAVBAR START */

.navBar{
  
  background: linear-gradient(to right, rgb(86, 166, 255), rgb(132, 169, 210), rgb(255,255,255));
  color: #000;
  /* padding-left: 85px;
  padding-right: 85px; */
  position: fixed;
  width: 100%;
  z-index: 1;

}


.navBarTop {
  display: flex;
  justify-content: end;
  border-bottom: 1px solid #0a0a0a;

}

.navTopPhoneAndMap {

  padding: 5px 50px 5px 0px;

}


.orderHakkoTubes {
  font-size: 24px;
  font-weight: bold;
  color: #fff;
  text-decoration: none;
  text-shadow: 0 0 10px rgba(255, 255, 255, 0.8), 0 0 20px rgba(0, 115, 230, 0.6);
  padding: 5px 50px 5px 0px;
  transition: all 0.3s ease-in-out;
}

.orderHakkoTubes:hover {
  text-shadow: 0 0 25px rgba(255, 255, 255, 1), 0 0 50px rgba(0, 115, 230, 1);
  color: #e0f7ff; 
  cursor: pointer;
}

.ncaGmapLink {
  text-decoration: none;
  color: inherit;
}
.mapMarker {

  width: 17px;
  position: relative; 
  top: 3px;
}

.navTop2 {
  padding-right: 333px;
}

.navBarBottom {
  display: flex;
  justify-content: center;

}
.ncaWhiteLogo {
  padding-top: 5px;
 
  
  }
/* .navBottomInnerBox{
  display: flex;
} */

.navUnorderedList {
  display: flex;
  align-items: center;
  padding-right: 48px;
  list-style: none;
  text-transform: uppercase;
  /* font-weight: bold; */
 
}

.industriesButton {

  background-color: transparent;
  border-width: 0;
  font-family: inherit;
  font-size: inherit;
  font-style: inherit;
  font-weight: inherit;
  line-height: inherit;
  padding: 0;
}





.inudstriesMenuBox {
  /* margin: auto;
  width: 150px;
  position: relative;
  right: -331px;
  bottom: 20px;
  text-align: left; */


  margin: auto;
  width: 250px;
  position: absolute;
  right: -56px;
  top: 25px;
  text-align: left;
  box-shadow: 8px 7px 5px black;
}


.inudstriesMenuBox > div {
  background-color: #CEE3FF;
}

.inudstriesMenuBox > div > a {
  text-decoration: none;
  color: black;
}


.menuBoxForRelative {

  position: relative;
}

.industriesLinkItem {
  border: 1px solid black;
  background-color: beige;
  text-align: center;
}

/* NAVBAR END */

.ncaGoogleMap {
  border: 0px none;
  width: 50%;
  height: 500px;
}

.contactUsBox {

  width: 50%;
  border: 3px solid black;
  background-color: #56A6FF;
  box-shadow: 5px 5px grey;
}

.contactUsMsgBox {
  width: 74%;
  height: 299px;

}
  
  .industriesClusterImage {
     
    width: 320px ;
    height: 200px ;
  }
  @media only screen and (max-width: 1726px) {
    .industriesClusterImage {
     
      width: 256px !important;
      height: 160px !important;
    }

  }

  .homeIndustryText {

    font-size: 20px;
    text-decoration: none;
    color: black;
    
    }
    
  @media only screen and (max-width: 1500px) {
    .industriesClusterImage {
     
      width: 160px !important;
      height: 100px !important;
    }

    .homeIndustryText {
      font-size: 14px;
      color: black;
    }

    .ncaWhiteLogo {
      padding-top: 9.5px;
      width: 41vw;
      padding-bottom: 9.5px;
    }

  }




@media only screen and (max-width: 1218px) {

  .aboutUsMainBox {
    padding-top: 200px !important;
 
    
  }

  .contactUsMainBox {

    padding-top: 200px !important;
  }

  .ncaHome {
    padding-top: 156px !important;
  }

  .ncaGoogleMap {
    border: 0px none; 
    width: 80%;
    height: 80vw;
    }


    
}

@media only screen and (max-width: 1216px) {




  .navUnorderedList {
    flex-direction: column;
   
  }

  .navListItem {
font-size: 15px !important;

  }

  .industriesBoxHolder {
    display: flex;
    justify-content: center;
    flex-direction: column;
}


  .ncaLogoBox {
    display: flex;
    flex-direction: column-reverse;
    justify-content: center;
}

.ncaWhiteLogo {
width: 55vw;

}


.navBarBottom {

  display: flex;
  justify-content: center;
  flex-direction: column;
  
  }

  .navUnorderedList {

    flex-direction: row;
    justify-content: center;
    
    }

.industryRailCarBannerCover {

padding-top: 101px;

}

.industryPrinterBannerCover {

padding-top: 101px;

}

.industryPlantBannerCover {

padding-top: 101px;

}

.industryConstructionBannerCover {

  padding-top: 101px;

}

.industryPlasticOpticalFiberBannerCover {

  padding-top: 101px;
}


.ncaEvents {
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: end;
  align-items: center;
  align-content: start;
}
    
  }



@media only screen and (max-width: 670px) {

.ncaWhiteLogo {
width: 60vw;

}
  }

  @media only screen and (max-width: 1108px){
    .navTop2 {
      padding-right: 0;
      
    }

    .navBarTop {
   
      justify-content: center;
      flex-direction: column;
  }
  .navTopPhoneAndMap {
    padding: 5px 0px 5px 0px;
  }

  }

@media only screen and (max-width: 600px){
  .ncaWhiteLogo {
    width: 90vw;
    padding: 10px 0 0 0;
   
    
    }

    /* .navListItem {
      border: 1px solid black;
      background-color: rgb(22, 117, 212);
      padding: 15px 1px 15px 1px !important;
      font-size: 17px !important;
      font-weight: bold;
      height: 17px;
      width: 87px;
      width: 40%;
      color: white !important;
      
        } */

        .navTopPhoneAndMap {
          font-size: 12px;
        }

        .navUnorderedList {
          padding:  0 10px;
        }

      

}



.navListItem {

padding: 0 10px;
font-size: 20px;
font-family: sans-serif;
text-decoration: none;
color: black;

-webkit-transition: color 0.8s;

}

.navListItem:hover{
 color: rgb(89, 156, 233);
 transition: 0.5s;
}

/* MAIN PAGE STYLING START */
.containerSlide {
  width: 650px;
  margin: auto;
padding-bottom: 20px;
}

.containerSlide img {
  height: 500px;

}

/* issue with otherslides overlapping */
.zoomInStyling {
  animation-name: slowZoom;
  animation-duration: 5s;
  animation-iteration-count:infinite;
  
animation-timing-function: ease;

}

@keyframes slowZoom {

  100%{ transform:scale(1.07, 1.07)}
0%{transform: scale(1, 1)}

}

.sliderImages {
 
}


ul.indicators {
  padding-left: 0;
}




.mainPageSlideShowTopDiv {

  width: 100%
}

.homeIndustriesMainBox {

  margin-bottom: 100px;
  
}




.industriesSperator {
  background-color: #4c87ca;
  opacity: 1;
  height: 2px;
  width: 50px;
  margin: 20px auto;

}


.homeHorizontalRule {

  background-color: #dbdbdb;
  height: 1px;
  width: 60%;
  margin: auto;
}

.industriesItem {
  padding: 0 15px;
}

.industriesBoxHolder {
  display: flex;
  justify-content: center;
}

.industriesImg4 {
width: 320px;
height: 200px;;

}

/* MAIN PAGE STYLING END */


/* .ncaWhiteLogo {

  border: 1px solid black;

} */
.ncaHome {

  padding-top: 100px;
  /* background: rgb(222, 222, 222); */
  

}



.contactUsMainBox {
  padding-top: 100px;
  padding-bottom: 200px;
  background: rgb(222, 222, 222);
  /* height: 700px; */

}


@media only screen and (max-width: 1110px)  {
  .contactUsMainBox {
    padding-top: 200px;

  
  }

  


}


/* MSIC START */
.textBorder {
  -webkit-text-stroke: .7px black;
}

/* MISC START */
/* ABOUT US START */
.aboutUsMainBox {
  padding-top: 100px;
  /* background: rgb(222, 222, 222); */
  
}
.aboutUsSperator {

   background-color: #4c87ca;
   opacity: 1;
   height: 2px;
   width: 50px;
   margin: auto;
   margin-bottom: 20px;
   
}
.vertRule {

  margin: 20px;
  color: rgba(115, 112, 112, 0.23);
}

 .aboutUsBlurbOne, .aboutUsBlurbTwo {
  text-align: left;
  padding: 10px;
  width: 50%;
 }

 .aboutUsBlurbOne p, .aboutUsBlurbTwo li {
   font-size: 20px;
 }

 .ncOutlineFirstParagaph {
  text-indent: 40px;
 }

.aboutUsBlurbOneAndTwo {
  display: flex;
  margin: auto;
  margin-bottom: 70px;
  width: 70%;
  padding: 10px;
  background-color: rgb(240 240 240);
  border-radius: 1%;

  border: 0px solid;
  padding: 10px;
  box-shadow: 5px 10px;

}

@media only screen and (max-width: 1110px) {

  .aboutUsBlurbOneAndTwo{
    width: 85%;
    flex-direction: column;
    align-items: center;
  }

  .aboutUsBlurbOne, .aboutUsBlurbTwo {
    width: 85%
  }


  .aboutUsMainBox {
    padding-top: 200px;
    /* background: rgb(222, 222, 222); */
    
  }


  .aboutUsBlurbOne p, .aboutUsBlurbTwo li {
    font-size: 20px;
  }




}

@media only screen and (max-width: 400px){
  .aboutUsBlurbOne, .aboutUsBlurbTwo {
    
    padding: 4px;
    
   }

}

.hqOutline {
  text-align: center;
}

.ncaHistory {
  text-align: center;
  
}

.ncaBranchesPic {

width: 55%;

}

@media only screen and (max-width: 1110px) {
  .ncaBranchesPic {

    width: 95%;
    
    }


}


/* ABOUT US END */





/* GLOW EFFECT TEST */

/* .glow-effect:hover {

  
    
    box-shadow: 0 20px 300px rgba(128, 227, 133, 0.4);
    background-color: none;
  
} */


/* ABOUT US END */


/* CONTACT US PAGE */







/* TESTING TEXT ON IMAGE */


/* TESTING TEXT ON IMAGE */

/* RAILCAR START PAGE  */

.industryRailCarBanner {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  padding-top: 100px;
}


.industryRailCarBannerCover {
  background: linear-gradient( rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3));
  margin-top: 0;
  padding-top: 45px ;
  padding: 80px;
  color:whitesmoke;
  font-weight: 600;
  font-size: 24px;
  font-family: Raleway,sans-serif;
  line-height: 1.384615384615385em;
  text-shadow: 3px 4px 1px rgba(0,0,0,.4); 
}


.industryRailCarPageSeperator {
  background-color: #4c87ca;
  opacity: 1;
  height: 2px;
  width: 22px;
  margin: auto;
  margin-bottom: 20px;
  margin-top: 20px;  
}

.bodyCont {
  display: flex;
  justify-content: center;

}

.table {
  font-family: Tahoma, sans-serif;
  display: grid;
  grid-template-columns: auto auto auto auto;
  justify-content: center;
  justify-items: center;
  align-content: space-evenly;
  align-items: center;
  width: 70%;
}



@media only screen and (max-width: 1000px) {

  .table{
    grid-template-columns: auto auto auto !important;
    width: 91%;
  }
 

}
@media only screen and (max-width: 600px) {

  .table{
    grid-template-columns: auto auto !important;
    width: 100%;
  }
 

}


.centerDiv{
  margin: auto;
  padding: 5px;

}

.table > div {
  padding: 8px;
margin: 0 20px;
}

.railProductsImgs {

  width: 100%;

}


/* child needs to have this even if you chame the element or tag */
.industryRailCarFlexMain > div {
  flex: 0 0 22.5494%;
  border: 1px solid black;
  margin: 5px;
}


.test {


}



/* RAILCAR END PAGE  */

/* ------------------- */

/* EXTRUDED RUBBER PAGE START */
.extrudedRubberPage {

  padding-top: 101px;
/* needs to be like 200px at smaller sizes */
}


/* EXTRUDED RUBBER PAGE END */

/* ------------------- */


/* PRINTER START PAGE */
.industryPrinterBanner {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  padding-top: 100px;
}


.industryPrinterBannerCover {
  background: linear-gradient( rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3));
  margin-top: 0;
  padding-top: 45px ;
  padding: 80px;
  color:whitesmoke;
  font-weight: 600;
  font-size: 24px;
  font-family: Raleway,sans-serif;
  line-height: 1.384615384615385em;
  text-shadow: 3px 4px 1px rgba(0,0,0,.4); 
}


.industryPrinterPageSeperator {
  background-color: #4c87ca;
  opacity: 1;
  height: 2px;
  width: 22px;
  margin: auto;
  margin-bottom: 20px;
  margin-top: 20px;  
}

.printerImgs {

  width: 320px;
  height: 200px;
}

/* PRINTER END PAGE */

/* ---------------------------- */

/* PLANT START */
.industryPlantBanner {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  padding-top: 100px;
}


.industryPlantBannerCover {
  background: linear-gradient( rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3));
  margin-top: 0;
  padding-top: 45px;
  padding: 80px;
  color:whitesmoke;
  font-weight: 600;
  font-size: 24px;
  font-family: Raleway,sans-serif;
  line-height: 1.384615384615385em;
  text-shadow: 3px 4px 1px rgba(0,0,0,.4); 
}


.industryPlantPageSeperator {
  background-color: #4c87ca;
  opacity: 1;
  height: 2px;
  width: 22px;
  margin: auto;
  margin-bottom: 20px;
  margin-top: 20px;  
}

/* PLANT END */

/* ------------------------------ */

/* CONSTRUCTION START */

.industryConstructionBanner {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  padding-top: 100px;
}


.industryConstructionBannerCover {
  background: linear-gradient( rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3));
  margin-top: 0;
  padding-top: 45px ;
  padding: 80px;
  color:whitesmoke;
  font-weight: 600;
  font-size: 24px;
  font-family: Raleway,sans-serif;
  line-height: 1.384615384615385em;
  text-shadow: 3px 4px 1px rgba(0,0,0,.4); 
}


.industryConstructionPageSeperator {
  background-color: #4c87ca;
  opacity: 1;
  height: 2px;
  width: 22px;
  margin: auto;
  margin-bottom: 20px;
  margin-top: 20px;  
}


/* CONSTRUCTION END */

/* ------------------------------ */

/* POF START */


.industryPlasticOpticalFiberBanner {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  padding-top: 100px;
}


.industryPlasticOpticalFiberBannerCover {
  background: linear-gradient( rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3));
  margin-top: 0;
  padding-top: 45px;
  padding: 80px;
  color:whitesmoke;
  font-weight: 600;
  font-size: 24px;
  font-family: Raleway,sans-serif;
  line-height: 1.384615384615385em;
  text-shadow: 3px 4px 1px rgba(0,0,0,.4); 
}


.industryPlasticOpticalFiberPageSeperator {
  background-color: #4c87ca;
  opacity: 1;
  height: 2px;
  width: 22px;
  margin: auto;
  margin-bottom: 20px;
  margin-top: 20px;  
}


.pofImgs {

  width: 320px !important;
  height: 200px !important;
}


/* POF END */

/* ------------------------------ */

/* EVENTS COMPONENT START */

.eventsComponentSeperator {

  background-color: #000000;
  opacity: 1;
  height: 2px;
  width: 22px;
  margin: auto;
  margin-bottom: 20px;
  margin-top: 20px;  
}


.eventsVariableComponent {

}

.ncaEvents {

  display: flex;
  width: 70%;

}

/* EVENTS COMPONENT END */


/* -=-=-=-=--=-=-=-=-=-=-=-=-=-=-=-=- */

.productPageBgColor {

  background-color: #F6F6F6;
  
}

.productImgViewer {

  background-repeat: no-repeat;
  background-size: 150px;
  height: 130px;
  width: 149px;
}

.productImgsMainPhoto {
  width: 100%;
  height: 534px;
}

.imgViewrBox {

}

.imgViewerFlex {
  width: 66.5%;
  display: flex;
}
  
  .imgViewerTop {
  
  display: flex;
  justify-content: left
  }
  
  .imgViewerPreviewImgs {
    width: 20%;
    max-height: 78px;
    overflow: hidden;
   
  }

  .imgViewerPreviewImgs:hover {
    opacity: .5;
    /* transform: rotate(35turn); */
    /* transition: 2s ease-in; */
    
    /* box-shadow: 1.5px 1.5px 5px;
    transition: .3s ease-out ; */
  }


.productTextCentering {

  margin: auto;

  padding: 10px;
  
  }
  .productDescripCentering {
  margin: auto;
  padding: 10px;
  }

.productDescriptions {
  text-align: left;
  font-size: 24px;
}
.productDescription1 {

  text-align: left;
  font-size: 24px;
}

/* @media only screen and (max-width: 1918px) {

  .leftArrow {
 
    right: 1427px !important;
  }

} */

.leftArrow {
  top: 45%;
  right: 74%;
}

.leftArrowImg {
  width: 51%;
}


.rightArrow {
  top: 45%;
  right: 22%;
}

.rightArrowImg {
  width: 51%;
}


.imgViewerFwdBckBtn {
  background-color: #afc7f0;
  border-radius: 42px;
  border: 7px solid #879bd6;
  display: inline-block;
  cursor: pointer;
  color: #ffffff;
  font-family: Impact;
  font-size: 28px;
  padding: 7px 14px;
  text-decoration: none;
  position: absolute;
  opacity: .3;
  transition: all 1s ease;
  width: 4%; /*<--- NEW 6/16/2023*/
  height: 10%;
}
  .imgViewerFwdBckBtn:hover {
    background-color:#476e9e;
    opacity: 1;
    transition: all 1s ease;
  }
  /* .imgViewerFwdBckBtn:active {
    position:relative;
    top:1px;
  } */


  .productViewerBlockOverFlow {
    max-width: 100%;
    max-height: 534px;
    overflow: hidden;
  }
  
  .productPagesPaddingToEscapeSpacing {

    padding-top: 101px;
  }

  .removeLinkStyling {
    text-decoration: none;
    color: inherit;
    font-size: 24px;

  }

/*makes it so each page is centered ugh*/
.productPagesFormatter {
  width: 57.34%;
  margin: auto;
}

@media only screen and (max-width: 1000px) {

  .productPagesFormatter {
    width: 90.34%;
    margin: auto;
}

.productPagesPaddingToEscapeSpacing {
    padding-top: 175px;
}



}




.prodListItem {

  padding: 10px 0;

}

.prodListBgColorGrey {
  background-color: grey;
}

.selected {
  opacity: .5;
  box-shadow: 5px 5px 20px;

}

.testButtonBox {
  display: flex;
  justify-content: space-between;
}

.testBtnLeft {

  width: 13.5%;

}

.testBtnRight {
  width: 13.5%;

}

.textButtonsTopBox {

  border: 1px solid black;

}


.documentBtnHolderTop {

  display: flex;
  justify-content: right;
}
.dcoumentBtnHolder {
display: flex;
flex-direction: column;
}

  .documentBtn {
    text-decoration: none;
    border: 2px solid #d9d5d0;
    padding: 10px 20px;
    margin: 10px 0;
    border-radius: 5px 5px;
    background-color: #56A6FF;
    box-shadow: 5px 5px 1px gray;
    color: whitesmoke;
    font-weight: 600;
    font-size: 20px;
    }
  .documentBtn:hover {
    color: black;
    background-color: #56a5ff44;

  }

  .documentBtn:active {
    box-shadow: 0px 0px;
    transform: translate(5px, 5px);
    border-style: inset;
    
  }
  
  .documentBtn:after {
    box-shadow: 5px 5px;
    transform: translate(0px, 0px);
  }

  .whoToEmailBlurb {

    display: flex;
    justify-content: right;
    padding: 15px 0;
    font-size: 15px;
    
    }

    .plidcoRfqInstructionsMainBox {
      display: flex;
      justify-content: right;
      text-align: left;
    }
    
    .rfqInstrucitonsMiddleDivForColumnFlexBox {
      text-align: left;
      box-shadow: 5px 5px 1px gray;
    }
    
    .rfqTitleBox {
      border: 1px solid;
      margin-bottom: 0px;
      background-color: #56A6FF;
      padding: 0 10px;
      margin-top: 0px;
    }
    
    .plidcoRfqInstructionsTable {
      border-bottom: 1px solid black;
      border-left: 1px solid black;
      border-right: 1px solid black;
      background-color: beige;
    }

    
    .embededPlidcoRfqForm {


      height: 1380px;
      margin: 20px;
      border: 1px solid black;
      box-shadow: 5px 5px 1px gray;
      }

    .fixIndustriesPageOverFlow {
      overflow: hidden;
      padding-bottom: 12%;
    }


    .pofSliderImage {
      width: 61% !important;
    }


.focusBorder {

  border: 3px solid black;
  background-color: thistle;
  box-shadow: 5px 5px black;
  margin: auto;
  width: 500px;
}

.contactUsFlexBox {
  margin: auto;
  display: flex;
  width: 70%;
}

.contactUsFlexBox > * {

  margin: 20px;

}

@media only screen and (max-width: 1300px) {
  .contactUsFlexBox {
    margin: auto;
    display: flex;
    width: 97%;
    flex-direction: column;
    align-items: center;
}


.contactUsBox {

  width: 79%
}

}

/* -=-=-=-=--=-=-=-=-=-=-=-=-=-=-=-=- */

/* FOOTER */


.footer {
  background-color: #4c87ca;
  /* below added 6/13/2023 */
  position: relative;
  /* top: 240px; */
 

}



.footerTopBox {
  display: flex;
  justify-content: center;

}

.footerTopBox > div {
  /* padding: 20px 185px 0 185px; */
  color: white;
  width: 25%;

}

.websiteCredit {
color: black;
text-decoration: none;
}


/* copy all of this  except for the footerr for 1216 media query and work backwards. */
@media only screen and (max-width: 600px) {
.footerTopBox > div {
  width: 65%;
  padding: 0 4px;

}
 

.footer {
  background-color: #4c87ca;
  font-size: 12px;
}


.leftArrow {
  top: 43%;
  right: 79%;
}


.rightArrow {
  top: 43%;
  right: 9%;
}


.productPagesPaddingToEscapeSpacing {
  padding-top: 175px !important;
}


.productPagesFormatter {
  width: 95.3%;
  margin: auto;
}
.productImgsMainPhoto {
  width: 100%;
  height: 185px;
}
  
.productDescription1 {
  text-align: left;
  font-size: 24px;
  width: 85%;
  
}

.productTitle {
  font-size: 11px;
}

.testBtnLeft {

  width: 20%;

}

.testBtnRight {
  width: 20%;

}

.embedRfqFormMainDiv {

  display: none;

}


.whoToEmailBlurb {

  display: flex;
  flex-direction: column;
  text-align: left;
  font-size:12px;
  
  }


/* .industryRailCarBanner {
  background-image: url(http://localhost:3000/static/media/banner-railcar.aad710a818e3bf8ce6bb.jpg);
  padding-top: 159px;
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: bottom;
}


.industryRailCarBannerCover {
  
  margin-top: 0;
  padding: 30px 80px;
    padding-top: 30px;
    padding-bottom: 30px;
  color: whitesmoke;
  font-weight: 600;
  font-size: 18px;
  font-family: Raleway,sans-serif;
  line-height: 1.384615384615385em;
  text-shadow: 3px 4px 1px rgba(0,0,0,.4);
  position: relative;
  top: 0px;
} */


/* .industryPrinterBanner {
  background-image: url("./images/industry-page-banner-img/banner-printer.jpg");
  padding-top: 159px;
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: bottom;
}

.industryPrinterBannerCover{

  margin-top: 0;
  padding: 30px 80px;
    padding-top: 30px;
    padding-bottom: 30px;
  color: whitesmoke;
  font-weight: 600;
  font-size: 18px;
  font-family: Raleway,sans-serif;
  line-height: 1.384615384615385em;
  text-shadow: 3px 4px 1px rgba(0,0,0,.4);
  position: relative;
  top: 0px;
} */

}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;;;AAIA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;;AAGA;;EAEE,YAAY;EACZ,UAAU;EACV,aAAa;AACf;;AAEA;EACE,uBAAuB;;EAEvB,YAAY;EACZ,WAAW;;EAEX,aAAa;AACf;;AAEA,iBAAiB;;AAEjB;;EAEE,8FAA8F;EAC9F,WAAW;EACX;wBACsB;EACtB,eAAe;EACf,WAAW;EACX,UAAU;;AAEZ;;;AAGA;EACE,aAAa;EACb,oBAAoB;EACpB,gCAAgC;;AAElC;;AAEA;;EAEE,yBAAyB;;AAE3B;;;AAGA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,qBAAqB;EACrB,+EAA+E;EAC/E,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,2EAA2E;EAC3E,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;;AAEzB;AACA;EACE,gBAAgB;;;EAGhB;AACF;;GAEG;;AAEH;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;;AAEzB;;AAEA;;EAEE,6BAA6B;EAC7B,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,UAAU;AACZ;;;;;;AAMA;EACE;;;;;qBAKmB;;;EAGnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,6BAA6B;AAC/B;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;;AAGA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,eAAe;;AAEf;EACE,gBAAgB;EAChB,UAAU;EACV,aAAa;AACf;;AAEA;;EAEE,UAAU;EACV,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,aAAa;;AAEf;;EAEE;;IAEE,aAAa;IACb,cAAc;EAChB;EACA;IACE;;MAEE,uBAAuB;MACvB,wBAAwB;IAC1B;;EAEF;;EAEA;;IAEE,eAAe;IACf,qBAAqB;IACrB,YAAY;;IAEZ;;EAEF;IACE;;MAEE,uBAAuB;MACvB,wBAAwB;IAC1B;;IAEA;MACE,eAAe;MACf,YAAY;IACd;;IAEA;MACE,kBAAkB;MAClB,WAAW;MACX,qBAAqB;IACvB;;EAEF;;;;;AAKF;;EAEE;IACE,6BAA6B;;;EAG/B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ;;;;AAIJ;;AAEA;;;;;EAKE;IACE,sBAAsB;;EAExB;;EAEA;AACF,0BAA0B;;EAExB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,sBAAsB;AAC1B;;;EAGE;IACE,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;AACA,WAAW;;AAEX;;;AAGA;;EAEE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;;EAEtB;;EAEA;;IAEE,mBAAmB;IACnB,uBAAuB;;IAEvB;;AAEJ;;AAEA,kBAAkB;;AAElB;;AAEA;;AAEA,kBAAkB;;AAElB;;AAEA;;AAEA,kBAAkB;;AAElB;;AAEA;;EAEE,kBAAkB;;AAEpB;;AAEA;;EAEE,kBAAkB;AACpB;;;AAGA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;AACtB;;EAEE;;;;AAIF;;AAEA;AACA,WAAW;;AAEX;EACE;;EAEA;IACE;MACE,gBAAgB;;IAElB;;IAEA;;MAEE,uBAAuB;MACvB,sBAAsB;EAC1B;EACA;IACE,wBAAwB;EAC1B;;EAEA;;AAEF;EACE;IACE,WAAW;IACX,mBAAmB;;;IAGnB;;IAEA;;;;;;;;;;;WAWO;;QAEH;UACE,eAAe;QACjB;;QAEA;UACE,gBAAgB;QAClB;;;;AAIR;;;;AAIA;;AAEA,eAAe;AACf,eAAe;AACf,uBAAuB;AACvB,qBAAqB;AACrB,YAAY;;AAEZ,8BAA8B;;AAE9B;;AAEA;CACC,wBAAwB;CACxB,gBAAgB;AACjB;;AAEA,4BAA4B;AAC5B;EACE,YAAY;EACZ,YAAY;AACd,oBAAoB;AACpB;;AAEA;EACE,aAAa;;AAEf;;AAEA,uCAAuC;AACvC;EACE,wBAAwB;EACxB,sBAAsB;EACtB,kCAAkC;;AAEpC,+BAA+B;;AAE/B;;AAEA;;EAEE,MAAM,2BAA2B;AACnC,GAAG,sBAAsB;;AAEzB;;AAEA;;AAEA;;;AAGA;EACE,eAAe;AACjB;;;;;AAKA;;EAEE;AACF;;AAEA;;EAEE,oBAAoB;;AAEtB;;;;;AAKA;EACE,yBAAyB;EACzB,UAAU;EACV,WAAW;EACX,WAAW;EACX,iBAAiB;;AAEnB;;;AAGA;;EAEE,yBAAyB;EACzB,WAAW;EACX,UAAU;EACV,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;AACA,YAAY;AACZ,aAAa;;AAEb;;AAEA,0BAA0B;;;AAG1B;;;;GAIG;AACH;;EAEE,kBAAkB;EAClB,oCAAoC;;;AAGtC;;;;AAIA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;;AAErB;;;AAGA;EACE;IACE,kBAAkB;;;EAGpB;;;;;AAKF;;;AAGA,eAAe;AACf;EACE,+BAA+B;AACjC;;AAEA,eAAe;AACf,mBAAmB;AACnB;EACE,kBAAkB;EAClB,oCAAoC;;AAEtC;AACA;;GAEG,yBAAyB;GACzB,UAAU;GACV,WAAW;GACX,WAAW;GACX,YAAY;GACZ,mBAAmB;;AAEtB;AACA;;EAEE,YAAY;EACZ,gCAAgC;AAClC;;CAEC;EACC,gBAAgB;EAChB,aAAa;EACb,UAAU;CACX;;CAEA;GACE,eAAe;CACjB;;CAEA;EACC,iBAAiB;CAClB;;AAED;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,kCAAkC;EAClC,iBAAiB;;EAEjB,iBAAiB;EACjB,aAAa;EACb,oBAAoB;;AAEtB;;AAEA;;EAEE;IACE,UAAU;IACV,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE;EACF;;;EAGA;IACE,kBAAkB;IAClB,oCAAoC;;EAEtC;;;EAGA;IACE,eAAe;EACjB;;;;;AAKF;;AAEA;EACE;;IAEE,YAAY;;GAEb;;AAEH;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;;AAEpB;;AAEA;;AAEA,UAAU;;AAEV;;AAEA;EACE;;IAEE,UAAU;;IAEV;;;AAGJ;;;AAGA,iBAAiB;;;;;;AAMjB,qBAAqB;;AAErB;;;;;;;GAOG;;;AAGH,iBAAiB;;;AAGjB,oBAAoB;;;;;;;;AAQpB,0BAA0B;;;AAG1B,0BAA0B;;AAE1B,wBAAwB;;AAExB;EACE,yDAA6E;EAC7E,kBAAkB;AACpB;;;AAGA;EACE,oEAAoE;EACpE,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,gCAAgC;EAChC,uCAAuC;AACzC;;;AAGA;EACE,yBAAyB;EACzB,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;;AAEzB;;AAEA;EACE,+BAA+B;EAC/B,aAAa;EACb,0CAA0C;EAC1C,uBAAuB;EACvB,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;EACnB,UAAU;AACZ;;;;AAIA;;EAEE;IACE,gDAAgD;IAChD,UAAU;EACZ;;;AAGF;AACA;;EAEE;IACE,2CAA2C;IAC3C,WAAW;EACb;;;AAGF;;;AAGA;EACE,YAAY;EACZ,YAAY;;AAEd;;AAEA;EACE,YAAY;AACd,cAAc;AACd;;AAEA;;EAEE,WAAW;;AAEb;;;AAGA,kEAAkE;AAClE;EACE,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;AACb;;;AAGA;;;AAGA;;;;AAIA,sBAAsB;;AAEtB,wBAAwB;;AAExB,+BAA+B;AAC/B;;EAEE,kBAAkB;AACpB,4CAA4C;AAC5C;;;AAGA,6BAA6B;;AAE7B,wBAAwB;;;AAGxB,uBAAuB;AACvB;EACE,yDAA6E;EAC7E,kBAAkB;AACpB;;;AAGA;EACE,oEAAoE;EACpE,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,gCAAgC;EAChC,uCAAuC;AACzC;;;AAGA;EACE,yBAAyB;EACzB,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,aAAa;AACf;;AAEA,qBAAqB;;AAErB,iCAAiC;;AAEjC,gBAAgB;AAChB;EACE,yDAA2E;EAC3E,kBAAkB;AACpB;;;AAGA;EACE,oEAAoE;EACpE,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,gCAAgC;EAChC,uCAAuC;AACzC;;;AAGA;EACE,yBAAyB;EACzB,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,cAAc;;AAEd,mCAAmC;;AAEnC,uBAAuB;;AAEvB;EACE,yDAAkF;EAClF,kBAAkB;AACpB;;;AAGA;EACE,oEAAoE;EACpE,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,gCAAgC;EAChC,uCAAuC;AACzC;;;AAGA;EACE,yBAAyB;EACzB,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;;AAGA,qBAAqB;;AAErB,mCAAmC;;AAEnC,cAAc;;;AAGd;EACE,yDAA+E;EAC/E,kBAAkB;AACpB;;;AAGA;EACE,oEAAoE;EACpE,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,gCAAgC;EAChC,uCAAuC;AACzC;;;AAGA;EACE,yBAAyB;EACzB,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;;AAGA;;EAEE,uBAAuB;EACvB,wBAAwB;AAC1B;;;AAGA,YAAY;;AAEZ,mCAAmC;;AAEnC,2BAA2B;;AAE3B;;EAEE,yBAAyB;EACzB,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;;AAGA;;AAEA;;AAEA;;EAEE,aAAa;EACb,UAAU;;AAEZ;;AAEA,yBAAyB;;;AAGzB,uCAAuC;;AAEvC;;EAEE,yBAAyB;;AAE3B;;AAEA;;EAEE,4BAA4B;EAC5B,sBAAsB;EACtB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;;AAEA;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;EAEE;;EAEA,aAAa;EACb;EACA;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,gBAAgB;;EAElB;;EAEA;IACE,WAAW;IACX,+BAA+B;IAC/B,4BAA4B;;IAE5B;gCAC4B;EAC9B;;;AAGF;;EAEE,YAAY;;EAEZ,aAAa;;EAEb;EACA;EACA,YAAY;EACZ,aAAa;EACb;;AAEF;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;;EAEE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;;;;;GAOG;;AAEH;EACE,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;;AAGA;EACE,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;;AAGA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,SAAS,EAAE,qBAAqB;EAChC,WAAW;AACb;EACE;IACE,wBAAwB;IACxB,UAAU;IACV,uBAAuB;EACzB;EACA;;;KAGG;;;EAGH;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,cAAc;IACd,eAAe;;EAEjB;;AAEF,wCAAwC;AACxC;EACE,aAAa;EACb,YAAY;AACd;;AAEA;;EAEE;IACE,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;;;AAIA;;;;;AAKA;;EAEE,eAAe;;AAEjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,wBAAwB;;AAE1B;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;;EAEE,YAAY;;AAEd;;AAEA;EACE,YAAY;;AAEd;;AAEA;;EAEE,uBAAuB;;AAEzB;;;AAGA;;EAEE,aAAa;EACb,sBAAsB;AACxB;AACA;AACA,aAAa;AACb,sBAAsB;AACtB;;EAEE;IACE,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,sBAAsB;IACtB,yBAAyB;IACzB,4BAA4B;IAC5B,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf;EACF;IACE,YAAY;IACZ,2BAA2B;;EAE7B;;EAEA;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;;EAErB;;EAEA;IACE,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;;IAEE,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,eAAe;;IAEf;;IAEA;MACE,aAAa;MACb,sBAAsB;MACtB,gBAAgB;IAClB;;IAEA;MACE,gBAAgB;MAChB,4BAA4B;IAC9B;;IAEA;MACE,iBAAiB;MACjB,kBAAkB;MAClB,yBAAyB;MACzB,eAAe;MACf,eAAe;IACjB;;IAEA;MACE,8BAA8B;MAC9B,4BAA4B;MAC5B,6BAA6B;MAC7B,uBAAuB;IACzB;;;IAGA;;;MAGE,cAAc;MACd,YAAY;MACZ,uBAAuB;MACvB,4BAA4B;MAC5B;;IAEF;MACE,gBAAgB;MAChB,mBAAmB;IACrB;;;IAGA;MACE,qBAAqB;IACvB;;;AAGJ;;EAEE,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;AACZ;;AAEA;;EAEE,YAAY;;AAEd;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;IACb,UAAU;IACV,sBAAsB;IACtB,mBAAmB;AACvB;;;AAGA;;EAEE;AACF;;AAEA;;AAEA,uCAAuC;;AAEvC,WAAW;;;AAGX;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;;;AAGlB;;;;AAIA;EACE,aAAa;EACb,uBAAuB;;AAEzB;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,UAAU;;AAEZ;;AAEA;AACA,YAAY;AACZ,qBAAqB;AACrB;;;AAGA,sFAAsF;AACtF;AACA;EACE,UAAU;EACV,cAAc;;AAEhB;;;AAGA;EACE,yBAAyB;EACzB,eAAe;AACjB;;;AAGA;EACE,QAAQ;EACR,UAAU;AACZ;;;AAGA;EACE,QAAQ;EACR,SAAS;AACX;;;AAGA;EACE,6BAA6B;AAC/B;;;AAGA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,UAAU;;AAEZ;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,UAAU;;AAEZ;;AAEA;EACE,UAAU;;AAEZ;;AAEA;;EAEE,aAAa;;AAEf;;;AAGA;;EAEE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;;EAEd;;;AAGF;;;;;;;;;;;;;;;;;;;;;;;GAuBG;;;AAGH;;;;;;;;;;;;;;;;;;;;;;GAsBG;;AAEH","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n\n.center {\n\n  margin: auto;\n  width: 50%;\n  padding: 10px;\n}\n\n.helloBox {\n  border: 1px solid black;\n  \n  margin: auto;\n  width: 30vw;\n  \n  padding: 10px;\n}\n\n/* NAVBAR START */\n\n.navBar{\n  \n  background: linear-gradient(to right, rgb(86, 166, 255), rgb(132, 169, 210), rgb(255,255,255));\n  color: #000;\n  /* padding-left: 85px;\n  padding-right: 85px; */\n  position: fixed;\n  width: 100%;\n  z-index: 1;\n\n}\n\n\n.navBarTop {\n  display: flex;\n  justify-content: end;\n  border-bottom: 1px solid #0a0a0a;\n\n}\n\n.navTopPhoneAndMap {\n\n  padding: 5px 50px 5px 0px;\n\n}\n\n\n.orderHakkoTubes {\n  font-size: 24px;\n  font-weight: bold;\n  color: #fff;\n  text-decoration: none;\n  text-shadow: 0 0 10px rgba(255, 255, 255, 0.8), 0 0 20px rgba(0, 115, 230, 0.6);\n  padding: 5px 50px 5px 0px;\n  transition: all 0.3s ease-in-out;\n}\n\n.orderHakkoTubes:hover {\n  text-shadow: 0 0 25px rgba(255, 255, 255, 1), 0 0 50px rgba(0, 115, 230, 1);\n  color: #e0f7ff; \n  cursor: pointer;\n}\n\n.ncaGmapLink {\n  text-decoration: none;\n  color: inherit;\n}\n.mapMarker {\n\n  width: 17px;\n  position: relative; \n  top: 3px;\n}\n\n.navTop2 {\n  padding-right: 333px;\n}\n\n.navBarBottom {\n  display: flex;\n  justify-content: center;\n\n}\n.ncaWhiteLogo {\n  padding-top: 5px;\n \n  \n  }\n/* .navBottomInnerBox{\n  display: flex;\n} */\n\n.navUnorderedList {\n  display: flex;\n  align-items: center;\n  padding-right: 48px;\n  list-style: none;\n  text-transform: uppercase;\n  /* font-weight: bold; */\n \n}\n\n.industriesButton {\n\n  background-color: transparent;\n  border-width: 0;\n  font-family: inherit;\n  font-size: inherit;\n  font-style: inherit;\n  font-weight: inherit;\n  line-height: inherit;\n  padding: 0;\n}\n\n\n\n\n\n.inudstriesMenuBox {\n  /* margin: auto;\n  width: 150px;\n  position: relative;\n  right: -331px;\n  bottom: 20px;\n  text-align: left; */\n\n\n  margin: auto;\n  width: 250px;\n  position: absolute;\n  right: -56px;\n  top: 25px;\n  text-align: left;\n  box-shadow: 8px 7px 5px black;\n}\n\n\n.inudstriesMenuBox > div {\n  background-color: #CEE3FF;\n}\n\n.inudstriesMenuBox > div > a {\n  text-decoration: none;\n  color: black;\n}\n\n\n.menuBoxForRelative {\n\n  position: relative;\n}\n\n.industriesLinkItem {\n  border: 1px solid black;\n  background-color: beige;\n  text-align: center;\n}\n\n/* NAVBAR END */\n\n.ncaGoogleMap {\n  border: 0px none;\n  width: 50%;\n  height: 500px;\n}\n\n.contactUsBox {\n\n  width: 50%;\n  border: 3px solid black;\n  background-color: #56A6FF;\n  box-shadow: 5px 5px grey;\n}\n\n.contactUsMsgBox {\n  width: 74%;\n  height: 299px;\n\n}\n  \n  .industriesClusterImage {\n     \n    width: 320px ;\n    height: 200px ;\n  }\n  @media only screen and (max-width: 1726px) {\n    .industriesClusterImage {\n     \n      width: 256px !important;\n      height: 160px !important;\n    }\n\n  }\n\n  .homeIndustryText {\n\n    font-size: 20px;\n    text-decoration: none;\n    color: black;\n    \n    }\n    \n  @media only screen and (max-width: 1500px) {\n    .industriesClusterImage {\n     \n      width: 160px !important;\n      height: 100px !important;\n    }\n\n    .homeIndustryText {\n      font-size: 14px;\n      color: black;\n    }\n\n    .ncaWhiteLogo {\n      padding-top: 9.5px;\n      width: 41vw;\n      padding-bottom: 9.5px;\n    }\n\n  }\n\n\n\n\n@media only screen and (max-width: 1218px) {\n\n  .aboutUsMainBox {\n    padding-top: 200px !important;\n \n    \n  }\n\n  .contactUsMainBox {\n\n    padding-top: 200px !important;\n  }\n\n  .ncaHome {\n    padding-top: 156px !important;\n  }\n\n  .ncaGoogleMap {\n    border: 0px none; \n    width: 80%;\n    height: 80vw;\n    }\n\n\n    \n}\n\n@media only screen and (max-width: 1216px) {\n\n\n\n\n  .navUnorderedList {\n    flex-direction: column;\n   \n  }\n\n  .navListItem {\nfont-size: 15px !important;\n\n  }\n\n  .industriesBoxHolder {\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n}\n\n\n  .ncaLogoBox {\n    display: flex;\n    flex-direction: column-reverse;\n    justify-content: center;\n}\n\n.ncaWhiteLogo {\nwidth: 55vw;\n\n}\n\n\n.navBarBottom {\n\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  \n  }\n\n  .navUnorderedList {\n\n    flex-direction: row;\n    justify-content: center;\n    \n    }\n\n.industryRailCarBannerCover {\n\npadding-top: 101px;\n\n}\n\n.industryPrinterBannerCover {\n\npadding-top: 101px;\n\n}\n\n.industryPlantBannerCover {\n\npadding-top: 101px;\n\n}\n\n.industryConstructionBannerCover {\n\n  padding-top: 101px;\n\n}\n\n.industryPlasticOpticalFiberBannerCover {\n\n  padding-top: 101px;\n}\n\n\n.ncaEvents {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  justify-content: end;\n  align-items: center;\n  align-content: start;\n}\n    \n  }\n\n\n\n@media only screen and (max-width: 670px) {\n\n.ncaWhiteLogo {\nwidth: 60vw;\n\n}\n  }\n\n  @media only screen and (max-width: 1108px){\n    .navTop2 {\n      padding-right: 0;\n      \n    }\n\n    .navBarTop {\n   \n      justify-content: center;\n      flex-direction: column;\n  }\n  .navTopPhoneAndMap {\n    padding: 5px 0px 5px 0px;\n  }\n\n  }\n\n@media only screen and (max-width: 600px){\n  .ncaWhiteLogo {\n    width: 90vw;\n    padding: 10px 0 0 0;\n   \n    \n    }\n\n    /* .navListItem {\n      border: 1px solid black;\n      background-color: rgb(22, 117, 212);\n      padding: 15px 1px 15px 1px !important;\n      font-size: 17px !important;\n      font-weight: bold;\n      height: 17px;\n      width: 87px;\n      width: 40%;\n      color: white !important;\n      \n        } */\n\n        .navTopPhoneAndMap {\n          font-size: 12px;\n        }\n\n        .navUnorderedList {\n          padding:  0 10px;\n        }\n\n      \n\n}\n\n\n\n.navListItem {\n\npadding: 0 10px;\nfont-size: 20px;\nfont-family: sans-serif;\ntext-decoration: none;\ncolor: black;\n\n-webkit-transition: color 0.8s;\n\n}\n\n.navListItem:hover{\n color: rgb(89, 156, 233);\n transition: 0.5s;\n}\n\n/* MAIN PAGE STYLING START */\n.containerSlide {\n  width: 650px;\n  margin: auto;\npadding-bottom: 20px;\n}\n\n.containerSlide img {\n  height: 500px;\n\n}\n\n/* issue with otherslides overlapping */\n.zoomInStyling {\n  animation-name: slowZoom;\n  animation-duration: 5s;\n  animation-iteration-count:infinite;\n  \nanimation-timing-function: ease;\n\n}\n\n@keyframes slowZoom {\n\n  100%{ transform:scale(1.07, 1.07)}\n0%{transform: scale(1, 1)}\n\n}\n\n.sliderImages {\n \n}\n\n\nul.indicators {\n  padding-left: 0;\n}\n\n\n\n\n.mainPageSlideShowTopDiv {\n\n  width: 100%\n}\n\n.homeIndustriesMainBox {\n\n  margin-bottom: 100px;\n  \n}\n\n\n\n\n.industriesSperator {\n  background-color: #4c87ca;\n  opacity: 1;\n  height: 2px;\n  width: 50px;\n  margin: 20px auto;\n\n}\n\n\n.homeHorizontalRule {\n\n  background-color: #dbdbdb;\n  height: 1px;\n  width: 60%;\n  margin: auto;\n}\n\n.industriesItem {\n  padding: 0 15px;\n}\n\n.industriesBoxHolder {\n  display: flex;\n  justify-content: center;\n}\n\n.industriesImg4 {\nwidth: 320px;\nheight: 200px;;\n\n}\n\n/* MAIN PAGE STYLING END */\n\n\n/* .ncaWhiteLogo {\n\n  border: 1px solid black;\n\n} */\n.ncaHome {\n\n  padding-top: 100px;\n  /* background: rgb(222, 222, 222); */\n  \n\n}\n\n\n\n.contactUsMainBox {\n  padding-top: 100px;\n  padding-bottom: 200px;\n  background: rgb(222, 222, 222);\n  /* height: 700px; */\n\n}\n\n\n@media only screen and (max-width: 1110px)  {\n  .contactUsMainBox {\n    padding-top: 200px;\n\n  \n  }\n\n  \n\n\n}\n\n\n/* MSIC START */\n.textBorder {\n  -webkit-text-stroke: .7px black;\n}\n\n/* MISC START */\n/* ABOUT US START */\n.aboutUsMainBox {\n  padding-top: 100px;\n  /* background: rgb(222, 222, 222); */\n  \n}\n.aboutUsSperator {\n\n   background-color: #4c87ca;\n   opacity: 1;\n   height: 2px;\n   width: 50px;\n   margin: auto;\n   margin-bottom: 20px;\n   \n}\n.vertRule {\n\n  margin: 20px;\n  color: rgba(115, 112, 112, 0.23);\n}\n\n .aboutUsBlurbOne, .aboutUsBlurbTwo {\n  text-align: left;\n  padding: 10px;\n  width: 50%;\n }\n\n .aboutUsBlurbOne p, .aboutUsBlurbTwo li {\n   font-size: 20px;\n }\n\n .ncOutlineFirstParagaph {\n  text-indent: 40px;\n }\n\n.aboutUsBlurbOneAndTwo {\n  display: flex;\n  margin: auto;\n  margin-bottom: 70px;\n  width: 70%;\n  padding: 10px;\n  background-color: rgb(240 240 240);\n  border-radius: 1%;\n\n  border: 0px solid;\n  padding: 10px;\n  box-shadow: 5px 10px;\n\n}\n\n@media only screen and (max-width: 1110px) {\n\n  .aboutUsBlurbOneAndTwo{\n    width: 85%;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .aboutUsBlurbOne, .aboutUsBlurbTwo {\n    width: 85%\n  }\n\n\n  .aboutUsMainBox {\n    padding-top: 200px;\n    /* background: rgb(222, 222, 222); */\n    \n  }\n\n\n  .aboutUsBlurbOne p, .aboutUsBlurbTwo li {\n    font-size: 20px;\n  }\n\n\n\n\n}\n\n@media only screen and (max-width: 400px){\n  .aboutUsBlurbOne, .aboutUsBlurbTwo {\n    \n    padding: 4px;\n    \n   }\n\n}\n\n.hqOutline {\n  text-align: center;\n}\n\n.ncaHistory {\n  text-align: center;\n  \n}\n\n.ncaBranchesPic {\n\nwidth: 55%;\n\n}\n\n@media only screen and (max-width: 1110px) {\n  .ncaBranchesPic {\n\n    width: 95%;\n    \n    }\n\n\n}\n\n\n/* ABOUT US END */\n\n\n\n\n\n/* GLOW EFFECT TEST */\n\n/* .glow-effect:hover {\n\n  \n    \n    box-shadow: 0 20px 300px rgba(128, 227, 133, 0.4);\n    background-color: none;\n  \n} */\n\n\n/* ABOUT US END */\n\n\n/* CONTACT US PAGE */\n\n\n\n\n\n\n\n/* TESTING TEXT ON IMAGE */\n\n\n/* TESTING TEXT ON IMAGE */\n\n/* RAILCAR START PAGE  */\n\n.industryRailCarBanner {\n  background-image: url(\"./images/industry-page-banner-img/banner-railcar.jpg\");\n  padding-top: 100px;\n}\n\n\n.industryRailCarBannerCover {\n  background: linear-gradient( rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3));\n  margin-top: 0;\n  padding-top: 45px ;\n  padding: 80px;\n  color:whitesmoke;\n  font-weight: 600;\n  font-size: 24px;\n  font-family: Raleway,sans-serif;\n  line-height: 1.384615384615385em;\n  text-shadow: 3px 4px 1px rgba(0,0,0,.4); \n}\n\n\n.industryRailCarPageSeperator {\n  background-color: #4c87ca;\n  opacity: 1;\n  height: 2px;\n  width: 22px;\n  margin: auto;\n  margin-bottom: 20px;\n  margin-top: 20px;  \n}\n\n.bodyCont {\n  display: flex;\n  justify-content: center;\n\n}\n\n.table {\n  font-family: Tahoma, sans-serif;\n  display: grid;\n  grid-template-columns: auto auto auto auto;\n  justify-content: center;\n  justify-items: center;\n  align-content: space-evenly;\n  align-items: center;\n  width: 70%;\n}\n\n\n\n@media only screen and (max-width: 1000px) {\n\n  .table{\n    grid-template-columns: auto auto auto !important;\n    width: 91%;\n  }\n \n\n}\n@media only screen and (max-width: 600px) {\n\n  .table{\n    grid-template-columns: auto auto !important;\n    width: 100%;\n  }\n \n\n}\n\n\n.centerDiv{\n  margin: auto;\n  padding: 5px;\n\n}\n\n.table > div {\n  padding: 8px;\nmargin: 0 20px;\n}\n\n.railProductsImgs {\n\n  width: 100%;\n\n}\n\n\n/* child needs to have this even if you chame the element or tag */\n.industryRailCarFlexMain > div {\n  flex: 0 0 22.5494%;\n  border: 1px solid black;\n  margin: 5px;\n}\n\n\n.test {\n\n\n}\n\n\n\n/* RAILCAR END PAGE  */\n\n/* ------------------- */\n\n/* EXTRUDED RUBBER PAGE START */\n.extrudedRubberPage {\n\n  padding-top: 101px;\n/* needs to be like 200px at smaller sizes */\n}\n\n\n/* EXTRUDED RUBBER PAGE END */\n\n/* ------------------- */\n\n\n/* PRINTER START PAGE */\n.industryPrinterBanner {\n  background-image: url(\"./images/industry-page-banner-img/banner-printer.jpg\");\n  padding-top: 100px;\n}\n\n\n.industryPrinterBannerCover {\n  background: linear-gradient( rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3));\n  margin-top: 0;\n  padding-top: 45px ;\n  padding: 80px;\n  color:whitesmoke;\n  font-weight: 600;\n  font-size: 24px;\n  font-family: Raleway,sans-serif;\n  line-height: 1.384615384615385em;\n  text-shadow: 3px 4px 1px rgba(0,0,0,.4); \n}\n\n\n.industryPrinterPageSeperator {\n  background-color: #4c87ca;\n  opacity: 1;\n  height: 2px;\n  width: 22px;\n  margin: auto;\n  margin-bottom: 20px;\n  margin-top: 20px;  \n}\n\n.printerImgs {\n\n  width: 320px;\n  height: 200px;\n}\n\n/* PRINTER END PAGE */\n\n/* ---------------------------- */\n\n/* PLANT START */\n.industryPlantBanner {\n  background-image: url(\"./images/industry-page-banner-img/banner-plant.png\");\n  padding-top: 100px;\n}\n\n\n.industryPlantBannerCover {\n  background: linear-gradient( rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3));\n  margin-top: 0;\n  padding-top: 45px;\n  padding: 80px;\n  color:whitesmoke;\n  font-weight: 600;\n  font-size: 24px;\n  font-family: Raleway,sans-serif;\n  line-height: 1.384615384615385em;\n  text-shadow: 3px 4px 1px rgba(0,0,0,.4); \n}\n\n\n.industryPlantPageSeperator {\n  background-color: #4c87ca;\n  opacity: 1;\n  height: 2px;\n  width: 22px;\n  margin: auto;\n  margin-bottom: 20px;\n  margin-top: 20px;  \n}\n\n/* PLANT END */\n\n/* ------------------------------ */\n\n/* CONSTRUCTION START */\n\n.industryConstructionBanner {\n  background-image: url(\"./images/industry-page-banner-img/banner-construction.jpg\");\n  padding-top: 100px;\n}\n\n\n.industryConstructionBannerCover {\n  background: linear-gradient( rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3));\n  margin-top: 0;\n  padding-top: 45px ;\n  padding: 80px;\n  color:whitesmoke;\n  font-weight: 600;\n  font-size: 24px;\n  font-family: Raleway,sans-serif;\n  line-height: 1.384615384615385em;\n  text-shadow: 3px 4px 1px rgba(0,0,0,.4); \n}\n\n\n.industryConstructionPageSeperator {\n  background-color: #4c87ca;\n  opacity: 1;\n  height: 2px;\n  width: 22px;\n  margin: auto;\n  margin-bottom: 20px;\n  margin-top: 20px;  \n}\n\n\n/* CONSTRUCTION END */\n\n/* ------------------------------ */\n\n/* POF START */\n\n\n.industryPlasticOpticalFiberBanner {\n  background-image: url(\"./images/industry-page-banner-img/information-tech.png\");\n  padding-top: 100px;\n}\n\n\n.industryPlasticOpticalFiberBannerCover {\n  background: linear-gradient( rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3));\n  margin-top: 0;\n  padding-top: 45px;\n  padding: 80px;\n  color:whitesmoke;\n  font-weight: 600;\n  font-size: 24px;\n  font-family: Raleway,sans-serif;\n  line-height: 1.384615384615385em;\n  text-shadow: 3px 4px 1px rgba(0,0,0,.4); \n}\n\n\n.industryPlasticOpticalFiberPageSeperator {\n  background-color: #4c87ca;\n  opacity: 1;\n  height: 2px;\n  width: 22px;\n  margin: auto;\n  margin-bottom: 20px;\n  margin-top: 20px;  \n}\n\n\n.pofImgs {\n\n  width: 320px !important;\n  height: 200px !important;\n}\n\n\n/* POF END */\n\n/* ------------------------------ */\n\n/* EVENTS COMPONENT START */\n\n.eventsComponentSeperator {\n\n  background-color: #000000;\n  opacity: 1;\n  height: 2px;\n  width: 22px;\n  margin: auto;\n  margin-bottom: 20px;\n  margin-top: 20px;  \n}\n\n\n.eventsVariableComponent {\n\n}\n\n.ncaEvents {\n\n  display: flex;\n  width: 70%;\n\n}\n\n/* EVENTS COMPONENT END */\n\n\n/* -=-=-=-=--=-=-=-=-=-=-=-=-=-=-=-=- */\n\n.productPageBgColor {\n\n  background-color: #F6F6F6;\n  \n}\n\n.productImgViewer {\n\n  background-repeat: no-repeat;\n  background-size: 150px;\n  height: 130px;\n  width: 149px;\n}\n\n.productImgsMainPhoto {\n  width: 100%;\n  height: 534px;\n}\n\n.imgViewrBox {\n\n}\n\n.imgViewerFlex {\n  width: 66.5%;\n  display: flex;\n}\n  \n  .imgViewerTop {\n  \n  display: flex;\n  justify-content: left\n  }\n  \n  .imgViewerPreviewImgs {\n    width: 20%;\n    max-height: 78px;\n    overflow: hidden;\n   \n  }\n\n  .imgViewerPreviewImgs:hover {\n    opacity: .5;\n    /* transform: rotate(35turn); */\n    /* transition: 2s ease-in; */\n    \n    /* box-shadow: 1.5px 1.5px 5px;\n    transition: .3s ease-out ; */\n  }\n\n\n.productTextCentering {\n\n  margin: auto;\n\n  padding: 10px;\n  \n  }\n  .productDescripCentering {\n  margin: auto;\n  padding: 10px;\n  }\n\n.productDescriptions {\n  text-align: left;\n  font-size: 24px;\n}\n.productDescription1 {\n\n  text-align: left;\n  font-size: 24px;\n}\n\n/* @media only screen and (max-width: 1918px) {\n\n  .leftArrow {\n \n    right: 1427px !important;\n  }\n\n} */\n\n.leftArrow {\n  top: 45%;\n  right: 74%;\n}\n\n.leftArrowImg {\n  width: 51%;\n}\n\n\n.rightArrow {\n  top: 45%;\n  right: 22%;\n}\n\n.rightArrowImg {\n  width: 51%;\n}\n\n\n.imgViewerFwdBckBtn {\n  background-color: #afc7f0;\n  border-radius: 42px;\n  border: 7px solid #879bd6;\n  display: inline-block;\n  cursor: pointer;\n  color: #ffffff;\n  font-family: Impact;\n  font-size: 28px;\n  padding: 7px 14px;\n  text-decoration: none;\n  position: absolute;\n  opacity: .3;\n  transition: all 1s ease;\n  width: 4%; /*<--- NEW 6/16/2023*/\n  height: 10%;\n}\n  .imgViewerFwdBckBtn:hover {\n    background-color:#476e9e;\n    opacity: 1;\n    transition: all 1s ease;\n  }\n  /* .imgViewerFwdBckBtn:active {\n    position:relative;\n    top:1px;\n  } */\n\n\n  .productViewerBlockOverFlow {\n    max-width: 100%;\n    max-height: 534px;\n    overflow: hidden;\n  }\n  \n  .productPagesPaddingToEscapeSpacing {\n\n    padding-top: 101px;\n  }\n\n  .removeLinkStyling {\n    text-decoration: none;\n    color: inherit;\n    font-size: 24px;\n\n  }\n\n/*makes it so each page is centered ugh*/\n.productPagesFormatter {\n  width: 57.34%;\n  margin: auto;\n}\n\n@media only screen and (max-width: 1000px) {\n\n  .productPagesFormatter {\n    width: 90.34%;\n    margin: auto;\n}\n\n.productPagesPaddingToEscapeSpacing {\n    padding-top: 175px;\n}\n\n\n\n}\n\n\n\n\n.prodListItem {\n\n  padding: 10px 0;\n\n}\n\n.prodListBgColorGrey {\n  background-color: grey;\n}\n\n.selected {\n  opacity: .5;\n  box-shadow: 5px 5px 20px;\n\n}\n\n.testButtonBox {\n  display: flex;\n  justify-content: space-between;\n}\n\n.testBtnLeft {\n\n  width: 13.5%;\n\n}\n\n.testBtnRight {\n  width: 13.5%;\n\n}\n\n.textButtonsTopBox {\n\n  border: 1px solid black;\n\n}\n\n\n.documentBtnHolderTop {\n\n  display: flex;\n  justify-content: right;\n}\n.dcoumentBtnHolder {\ndisplay: flex;\nflex-direction: column;\n}\n\n  .documentBtn {\n    text-decoration: none;\n    border: 2px solid #d9d5d0;\n    padding: 10px 20px;\n    margin: 10px 0;\n    border-radius: 5px 5px;\n    background-color: #56A6FF;\n    box-shadow: 5px 5px 1px gray;\n    color: whitesmoke;\n    font-weight: 600;\n    font-size: 20px;\n    }\n  .documentBtn:hover {\n    color: black;\n    background-color: #56a5ff44;\n\n  }\n\n  .documentBtn:active {\n    box-shadow: 0px 0px;\n    transform: translate(5px, 5px);\n    border-style: inset;\n    \n  }\n  \n  .documentBtn:after {\n    box-shadow: 5px 5px;\n    transform: translate(0px, 0px);\n  }\n\n  .whoToEmailBlurb {\n\n    display: flex;\n    justify-content: right;\n    padding: 15px 0;\n    font-size: 15px;\n    \n    }\n\n    .plidcoRfqInstructionsMainBox {\n      display: flex;\n      justify-content: right;\n      text-align: left;\n    }\n    \n    .rfqInstrucitonsMiddleDivForColumnFlexBox {\n      text-align: left;\n      box-shadow: 5px 5px 1px gray;\n    }\n    \n    .rfqTitleBox {\n      border: 1px solid;\n      margin-bottom: 0px;\n      background-color: #56A6FF;\n      padding: 0 10px;\n      margin-top: 0px;\n    }\n    \n    .plidcoRfqInstructionsTable {\n      border-bottom: 1px solid black;\n      border-left: 1px solid black;\n      border-right: 1px solid black;\n      background-color: beige;\n    }\n\n    \n    .embededPlidcoRfqForm {\n\n\n      height: 1380px;\n      margin: 20px;\n      border: 1px solid black;\n      box-shadow: 5px 5px 1px gray;\n      }\n\n    .fixIndustriesPageOverFlow {\n      overflow: hidden;\n      padding-bottom: 12%;\n    }\n\n\n    .pofSliderImage {\n      width: 61% !important;\n    }\n\n\n.focusBorder {\n\n  border: 3px solid black;\n  background-color: thistle;\n  box-shadow: 5px 5px black;\n  margin: auto;\n  width: 500px;\n}\n\n.contactUsFlexBox {\n  margin: auto;\n  display: flex;\n  width: 70%;\n}\n\n.contactUsFlexBox > * {\n\n  margin: 20px;\n\n}\n\n@media only screen and (max-width: 1300px) {\n  .contactUsFlexBox {\n    margin: auto;\n    display: flex;\n    width: 97%;\n    flex-direction: column;\n    align-items: center;\n}\n\n\n.contactUsBox {\n\n  width: 79%\n}\n\n}\n\n/* -=-=-=-=--=-=-=-=-=-=-=-=-=-=-=-=- */\n\n/* FOOTER */\n\n\n.footer {\n  background-color: #4c87ca;\n  /* below added 6/13/2023 */\n  position: relative;\n  /* top: 240px; */\n \n\n}\n\n\n\n.footerTopBox {\n  display: flex;\n  justify-content: center;\n\n}\n\n.footerTopBox > div {\n  /* padding: 20px 185px 0 185px; */\n  color: white;\n  width: 25%;\n\n}\n\n.websiteCredit {\ncolor: black;\ntext-decoration: none;\n}\n\n\n/* copy all of this  except for the footerr for 1216 media query and work backwards. */\n@media only screen and (max-width: 600px) {\n.footerTopBox > div {\n  width: 65%;\n  padding: 0 4px;\n\n}\n \n\n.footer {\n  background-color: #4c87ca;\n  font-size: 12px;\n}\n\n\n.leftArrow {\n  top: 43%;\n  right: 79%;\n}\n\n\n.rightArrow {\n  top: 43%;\n  right: 9%;\n}\n\n\n.productPagesPaddingToEscapeSpacing {\n  padding-top: 175px !important;\n}\n\n\n.productPagesFormatter {\n  width: 95.3%;\n  margin: auto;\n}\n.productImgsMainPhoto {\n  width: 100%;\n  height: 185px;\n}\n  \n.productDescription1 {\n  text-align: left;\n  font-size: 24px;\n  width: 85%;\n  \n}\n\n.productTitle {\n  font-size: 11px;\n}\n\n.testBtnLeft {\n\n  width: 20%;\n\n}\n\n.testBtnRight {\n  width: 20%;\n\n}\n\n.embedRfqFormMainDiv {\n\n  display: none;\n\n}\n\n\n.whoToEmailBlurb {\n\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n  font-size:12px;\n  \n  }\n\n\n/* .industryRailCarBanner {\n  background-image: url(http://localhost:3000/static/media/banner-railcar.aad710a818e3bf8ce6bb.jpg);\n  padding-top: 159px;\n  background-repeat: no-repeat;\n  background-size: 100%;\n  background-position: bottom;\n}\n\n\n.industryRailCarBannerCover {\n  \n  margin-top: 0;\n  padding: 30px 80px;\n    padding-top: 30px;\n    padding-bottom: 30px;\n  color: whitesmoke;\n  font-weight: 600;\n  font-size: 18px;\n  font-family: Raleway,sans-serif;\n  line-height: 1.384615384615385em;\n  text-shadow: 3px 4px 1px rgba(0,0,0,.4);\n  position: relative;\n  top: 0px;\n} */\n\n\n/* .industryPrinterBanner {\n  background-image: url(\"./images/industry-page-banner-img/banner-printer.jpg\");\n  padding-top: 159px;\n  background-repeat: no-repeat;\n  background-size: 100%;\n  background-position: bottom;\n}\n\n.industryPrinterBannerCover{\n\n  margin-top: 0;\n  padding: 30px 80px;\n    padding-top: 30px;\n    padding-bottom: 30px;\n  color: whitesmoke;\n  font-weight: 600;\n  font-size: 18px;\n  font-family: Raleway,sans-serif;\n  line-height: 1.384615384615385em;\n  text-shadow: 3px 4px 1px rgba(0,0,0,.4);\n  position: relative;\n  top: 0px;\n} */\n\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
